import React from "react";

interface SearchIconProps {
  className?: string; // necessary to style the component using the "styled-components" library
}

const SearchIcon = ({ className }: SearchIconProps) => (
  <svg
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3871 20.4217L17.9174 19.8913L17.9174 19.8913L17.3871 20.4217ZM20.1795 17.6292L20.7098 17.0989L20.7098 17.0989L20.1795 17.6292ZM18.7881 15.1772C18.4952 14.8843 18.0204 14.8844 17.7275 15.1772C17.4346 15.4701 17.4346 15.945 17.7275 16.2379L18.7881 15.1772ZM15.9957 17.9697C15.7028 17.6768 15.2279 17.6768 14.9351 17.9697C14.6422 18.2626 14.6422 18.7374 14.9351 19.0303L15.9957 17.9697ZM1.50781 9.5C1.50781 5.21979 4.97761 1.75 9.25781 1.75V0.25C4.14918 0.25 0.0078125 4.39137 0.0078125 9.5H1.50781ZM9.25781 1.75C13.538 1.75 17.0078 5.21979 17.0078 9.5H18.5078C18.5078 4.39137 14.3664 0.25 9.25781 0.25V1.75ZM17.0078 9.5C17.0078 13.7802 13.538 17.25 9.25781 17.25V18.75C14.3664 18.75 18.5078 14.6086 18.5078 9.5H17.0078ZM9.25781 17.25C4.97761 17.25 1.50781 13.7802 1.50781 9.5H0.0078125C0.0078125 14.6086 4.14918 18.75 9.25781 18.75V17.25ZM19.6492 19.8913C19.171 20.3696 18.3956 20.3696 17.9174 19.8913L16.8567 20.952C17.9207 22.016 19.6458 22.016 20.7098 20.952L19.6492 19.8913ZM19.6492 18.1596C20.1274 18.6378 20.1274 19.4131 19.6492 19.8913L20.7098 20.952C21.7738 19.888 21.7738 18.1629 20.7098 17.0989L19.6492 18.1596ZM17.7275 16.2379L19.6492 18.1596L20.7098 17.0989L18.7881 15.1772L17.7275 16.2379ZM17.9174 19.8913L15.9957 17.9697L14.9351 19.0303L16.8567 20.952L17.9174 19.8913Z"
      fill="currentColor"
    />
  </svg>
);

export default SearchIcon;
